























import {Component, Vue} from 'vue-property-decorator'
import Utils from '../utils'
import {Action, State} from 'vuex-class'
import {
  AppConfig,
  EstimateCategories, ReservationResponse,
  SearchRequest,
  VehicleCategory,
  VehicleSlot,
} from '@/lib/kepler/interfaces'
import Locate, {Position} from '../lib/location'
import sdk from '../lib/kepler/sdk'
import {PopupState} from '@/store'
import AutoComplete from '@/components/proxy/Inputs/AutoComplete.vue'
import SelectTag from '@/components/proxy/Inputs/SelectTag.vue'
import TextField from '@/components/proxy/Inputs/TextField.vue'
import moment from 'moment'
import VehicleBookingSummary from '@/components/entities/vehicle/VehicleBookingSummary.vue'

class PositionClass {
  public lat: number
  public lng: number
  public acc: number | null

  constructor(lat?: number, lng?: number, acc?: number | null) {
    this.lat = lat || 0
    this.lng = lng || 0
    this.acc = acc || null
  }
}

@Component({
  components: {
    TextField,
    SelectTag,
    AutoComplete,
    IsLogged: Utils.loadComponent('IsLogged'),
    VehicleBookingDateTimeSelect: Utils.loadView('Vehicle/VehicleBookingDateTimeSelect'),
    CheckInOutPicker: Utils.loadComponent('CheckInOutPicker'),
    Container: Utils.loadComponent('proxy/Container'),
    Layout: Utils.loadComponent('proxy/Layout'),
    FormTag: Utils.loadComponent('proxy/Inputs/FormTag'),
    Card: Utils.loadComponent('proxy/Card/Card'),
    Chip: Utils.loadComponent('proxy/Chip'),
    Button: Utils.loadComponent('Button'),
  },
  name: 'CorporateVehicleSearch',
})

export default class CorporateVehicleSearch extends Vue {
  @State((state) => state.configuration.appConfig) public appConfig!: AppConfig
  @State((state) => state.booking.categories) public categoriesState!: VehicleCategory[]
  @State((state) => state.profile.userPosition) public userPosition!: Position | null

  @Action('openPopup') public openPopup: any
  @Action('selectReservation') public selectReservation!: (r: ReservationResponse) => Promise<ReservationResponse>
  @Action('current') public current!: () => Promise<void | ReservationResponse[]>

  public searchComplete: boolean = false
  public position: PositionClass = new PositionClass()
  // TODO: use this for something
  public positionUnavailable: boolean = true
  public categories: any[] = []
  public features: any[] = []
  public bookingMode: string = 'CRT'
  public categoriesEstimate: EstimateCategories[] = []
  public loading: boolean = false
  public estimateLoading: boolean = false

  protected searchRequest: SearchRequest = {
    start: null,
    end: null,
    booking_mode: null,
    latitude: null,
    longitude: null,
    vehicle_type_id: null,
    vehicle_category_id: null,
  }
  protected searchResponse: VehicleSlot[] = []

  protected bookRequest: any = {
    start: null,
    end: null,
    parking_lot_id: null,
    vehicle_category_id: null,
    memo: '',
  }

  protected lots: any[] = []

  protected get selectedCategories() {
    return this.categories.filter((category, i) => {
      return category.selected
    })
  }

  protected created() {
    sdk.booking.getPrivateLots().then((r) => {
      this.lots = r.data
    })
  }

  protected categoryString(category: VehicleCategory) {
    let type = category.type.toLowerCase()
    const name = category.name.toLowerCase()
    type = name.includes(type) ? '' : type + ' - '
    return type + name
  }

  protected toggleCategory(category: any) {
    if (category.id === this.searchRequest.vehicle_category_id) {
      this.searchRequest.vehicle_category_id = null
      return
    }
    this.searchRequest.vehicle_category_id = category.id
  }

  protected selectedFeatures() {
    return this.features.filter((feature) => {
      return feature.selected === true
    })
  }

  protected populateFields(val: { start: number, end: number }) {
    this.bookRequest.start = val.start
    this.bookRequest.end = val.end
  }

  protected setCategories() {
    const arr = this.categoriesState
    if (arr) {
      arr.forEach((category) => {
        this.$set(category, 'selected', true)
      })
      if (this.$route.params.type) {
        arr.filter((cat) => {
          return cat.type === this.$route.params.type
        })
      }
      this.categories = arr
    }
  }

  protected setPos() {
    const conf = this.appConfig
    if (this.userPosition) {
      this.$set(this, 'position', this.userPosition)
    } else if (conf) {
      this.$set(this, 'position', new PositionClass(conf.default_latitude, conf.default_longitude))
    }
  }

  protected locate() {
    Locate.locate(
      (pos: Position) => {
        this.position = pos
      },
      this.position,
      () => {
        this.positionUnavailable = true
        // TODO: investigate further use for error callback
      },
    )
  }

  protected mounted() {
    this.setPos()
    this.setCategories()
    this.locate()
  }

  protected getCategoryEstimate() {
    const start = this.searchRequest.start as number
    const end = this.searchRequest.end as number
    const hours = (Math.abs(start - end as number) / 3600)
    this.estimateLoading = true
    sdk.booking.estimateAll({
      distance: Math.floor(hours * 7),
      start,
      end,
      booking_mode: this.bookingMode,
    }).then((r: any) => {
      this.categoriesEstimate = r.data
      this.estimateLoading = false
    }, () => {
      this.estimateLoading = false
    })
  }

  protected isCurrent(r: ReservationResponse) {
    if (r.start_timestamp && r.end_timestamp) {
      const start = moment(r.start_timestamp, 'X')
      const end = moment(r.end_timestamp, 'X')
      return moment().isBetween(start, end)
    }
  }

  protected isFuture(r: ReservationResponse) {
    if (r.start_timestamp) {
      const start = moment(r.start_timestamp, 'X')
      return moment().isBefore(start)
    }
  }

  protected submit() {
    this.loading = true
    sdk.booking.autoBook(this.bookRequest)
      .then((r) => {
        if (this.isCurrent(r.data)) {
          this.selectVehicle(r.data)
        } else if (this.isFuture(r.data)) {
          this.$router.push({name: 'history', hash: '#future', params: {reloadHistory: 'future'}})
        }
      })
      .catch((e) => {
        this.$log(e, 2)
        this.loading = false
      })
  }

  protected selectVehicle(r: ReservationResponse) {
    this.selectReservation(r).then(() => {
      this.current().then(() => {
        this.$router.push({name: 'home'}).then(() => {
          this.$router.push({name: 'reservation'})
        })
      })
    })
  }
}
